/* eslint-disable jira/filename-case */

// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { KEY_TASK_GROUP, ROOT_TASK } from '../../../common/constants.tsx';
import { pushToBackend } from '../../../common/utils/pushToBackend.tsx';
import type { State } from '../../model/types.tsx';

type TaskGroup = {
	previousTaskGroupParents: string[];
	currentTaskGroupParent: string;
};

const setTaskGroup =
	(taskGroup: TaskGroup, openTask?: string): Action<State> =>
	({ setState }) => {
		setState({ ...taskGroup, openTask: openTask || '' });

		pushToBackend({
			key: KEY_TASK_GROUP,
			value: {
				taskGroup,
			},
		});
	};

export const nextChangeTaskGroupParent =
	(newCurrentTaskGroupParent: string): Action<State> =>
	({ getState, dispatch }) => {
		const { previousTaskGroupParents, currentTaskGroupParent } = getState();

		if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) {
			// prevent infinite loop nesting
			return;
		}

		previousTaskGroupParents.push(currentTaskGroupParent);

		const taskGroup = {
			previousTaskGroupParents,
			currentTaskGroupParent: newCurrentTaskGroupParent,
		};
		dispatch(setTaskGroup(taskGroup));
	};

export const nextGoBackToPreviousTaskGroup =
	(): Action<State> =>
	({ dispatch, getState }) => {
		const { previousTaskGroupParents, currentTriggerForTaskGroupParent } = getState();
		const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;

		const newTaskGroupParent =
			previousTaskGroupParents.length === 0
				? ROOT_TASK
				: previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];

		const newPreviousTaskGroupParents = previousTaskGroupParents.slice(
			0,
			lastIndexOfPreviousTaskGroupParents,
		);

		const taskGroup = {
			previousTaskGroupParents: newPreviousTaskGroupParents,
			currentTaskGroupParent: newTaskGroupParent,
		};

		dispatch(setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
	};
